import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';
import Button from '../../Button';
import './RemoveButton.css';

/**
 * RemoveButton — internal to SinglePatch, GroupPatch and PatchCard.
 *
 * Figma: Button Tertiary/Black with an X, compacted to the icon (26×26) and
 * centred on the selected patch's top-right corner.
 */
const RemoveButton = ({ onClick, label = 'Remove', variant = 'black', className = '' }) => (
  <Button
    size="tertiary"
    variant={variant}
    iconOnly
    iconLeft={<X size={20} />}
    className={['cfg-remove-btn', className].filter(Boolean).join(' ')}
    onClick={onClick}
    aria-label={label}
  />
);

RemoveButton.propTypes = {
  /** Remove click handler */
  onClick: PropTypes.func,
  /** Accessible name */
  label: PropTypes.string,
  /** Button skin — black on a patch chip, `text` inside a PatchCard corner */
  variant: PropTypes.oneOf(['black', 'text']),
  /** Host placement class (e.g. `cfg-patch-card__remove`) */
  className: PropTypes.string,
};

export default RemoveButton;
